import "./css/style.css";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import DashBoard from "./pages/dashboard/DashBoard";
import Sidebar from "./components/sidebar/Sidebar";
import LoginPage from "./pages/login/LoginPage";
import Error from "./pages/error/error";
import PrivateRoute from "./route/RouteProtection";
import ManageDriver from "./pages/managedriver/ManageDriver";
import ManageRider from "./pages/managerider/ManageRider";
import RiderDetails from "./components/riderDetails/RiderDetails";
import DriverDetails from "./components/driverDetails/DriverDetails";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AllRides from "./pages/allRides/AllRides";
import CabTypes from "./pages/cabTypes/CabTypes";

function App() {
  const currentPath = useLocation();
  console.log("Why do you have to check console?")
  return (
    <>
    <ToastContainer />
      {currentPath.pathname !== "/login" && currentPath.pathname !== "/404" && (
        <Sidebar />
      )}
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute>
            <DashBoard />
            </PrivateRoute>
          }
        />
        <Route
          path="/cab-types"
          element={
            <PrivateRoute>
            <CabTypes />
            </PrivateRoute>
          }
        />
        <Route
          path="/manage-driver"
          element={
            <PrivateRoute>
            <ManageDriver />
            </PrivateRoute>
          }
        />
        <Route
          path="/manage-driver/:id"
          element={
            <PrivateRoute>
            <DriverDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/all-rides"
          element={
            <PrivateRoute>
            <AllRides />
            </PrivateRoute>
          }
        />
        <Route
          path="/manage-rider"
          element={
            <PrivateRoute>
            <ManageRider />
            </PrivateRoute>
          }
        />
        <Route
          path="/manage-rider/:id"
          element={
            <PrivateRoute>
            <RiderDetails />
            </PrivateRoute>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/404" element={<Error />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </>
  );
}

export default App;
